import { z } from 'zod';
// Mirror of the Prisma enums in schema.prisma for the Phase 9 matching
// + shift-lifecycle subsystem. Adding a value here is a deliberate
// three-place change: Prisma enum + this schema + a passing test.
export const MatchingStateSchema = z.enum([
    'SCHEDULED', // Phase 21 (3.1-2) — queued, start >14d out, not yet broadcasting
    'MATCHING',
    'REBROADCASTING_T2',
    'PENDING_TARGETED',
    'FILLED',
    'EXPIRED_POOL_EXHAUSTED',
    'EXPIRED_TIME_HIT',
    'CANCELLED_BY_BUYER',
    'CANCELLED_BY_OPERATOR',
]);
export const OfferStatusSchema = z.enum([
    'PENDING',
    'ACCEPTED',
    'DECLINED',
    'EXPIRED',
    'RESCINDED',
]);
export const ShiftStatusSchema = z.enum([
    'SCHEDULED',
    'IN_PROGRESS',
    'COMPLETED',
    'NO_SHOW',
    'CANCELLED',
    'DISPUTED',
]);
export const ShiftEventTypeSchema = z.enum([
    'CREATED',
    'ACCEPTED',
    'STARTED',
    'COMPLETED',
    'CANCELLED',
    'NO_SHOW',
    'DISPUTED',
    'CORRECTED',
]);
export const AvailabilityRecurrenceTypeSchema = z.enum(['ONE_OFF', 'WEEKLY']);
export const RequestingEntityTypeSchema = z.enum(['FACILITY', 'HOMECARE_CLIENT']);
//# sourceMappingURL=enums.schema.js.map